import {BasicScenario} from '../../../../allkey/framework/parameters/BasicScenario';

export class ProcedureScenario extends BasicScenario {}

